/**
 * @generated SignedSource<<f0949a7c7fbddb67d043808d4e03d226>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type QuizEditorBannerModuleUsageQuery$variables = {
  id: string;
};
export type QuizEditorBannerModuleUsageQuery$data = {
  readonly usage: {
    readonly canGenerateQuizForModule?: boolean | null;
    readonly id: string;
  } | null;
};
export type QuizEditorBannerModuleUsageQuery = {
  response: QuizEditorBannerModuleUsageQuery$data;
  variables: QuizEditorBannerModuleUsageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canGenerateQuizForModule",
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuizEditorBannerModuleUsageQuery",
    "selections": [
      {
        "alias": "usage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuizEditorBannerModuleUsageQuery",
    "selections": [
      {
        "alias": "usage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "79ea90bde21b68dd31cb0875db910369",
    "id": null,
    "metadata": {},
    "name": "QuizEditorBannerModuleUsageQuery",
    "operationKind": "query",
    "text": "query QuizEditorBannerModuleUsageQuery(\n  $id: ID!\n) {\n  usage: node(id: $id) {\n    __typename\n    id\n    ... on ContentUsage {\n      id\n      canGenerateQuizForModule\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd224824d0330ae08a87f2c217b7105e";

export default node;
